import React, { useEffect } from 'react'
import { useState } from "react";

import { makeStyles } from '@material-ui/core/styles';

import LoadingComponent from '../../../../components/Loading';

import { useSelector } from "react-redux";

import {
    selectUsuarioSeleccionado,
} from "../../../../redux/reducer/loginReducer";
import EmptyComponent from '../../../../components/EmptyContent';
// import { deleteInquilino, getAlumnos, inquilinoDelete } from '../../../../services/Alumnos';
import { Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
// import { GridActionsCellItem, GridToolbarDensitySelector, GridToolbarFilterButton} from '@mui/x-data-grid';
import EditIcon from '@material-ui/icons/Edit';
import SyncIcon from '@material-ui/icons/Sync';
import Swal from 'sweetalert2';
import { Link, useHistory } from 'react-router-dom';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import TituloPagina from '../../../../components/Titulos/TituloPagina';
import AddIcon from '@material-ui/icons/Add';
import { getAlumnos, getAlumnosInteraccion, update_comercial } from '../../../../services/alumnos';
import { Stack } from '@mui/system';
import {sincronizar_formularios, sincronizar_notion, sincronizar_woo_order} from '../../../../services/sincronizar'
import { getComerciales } from '../../../../services/comerciales';
import Moment from 'react-moment';
import { DataGridPro, GridActionsCellItem, GridToolbarDensitySelector, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import DataGridInnovattio from '../../../../components/DataGridInnovatiio';
import moment from 'moment/moment';

function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

// import Moment from 'react-moment';

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: '80px'
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "90vh"
    },
    emptyContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
        width: '100%',
        flexDirection: 'column',
        textAlign: 'center'
    },
    emptyImage: {
        width: '100%'
    },
    rootFilter: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
      },
    textFieldFilter: {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
        },
        margin: theme.spacing(1, 0.5, 1.5),
        '& .MuiSvgIcon-root': {
          marginRight: theme.spacing(0.5),
        },
        '& .MuiInput-underline:before': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    enlace: {
      color: theme.palette.link.main,
      textDecoration: 'none'
    }
}));

export default function AlumnosInteraccionContent() {
    const classes = useStyles();

    const [Alumnos, setAlumnos] = useState([]);
    const [loading, setLoading] = useState(false)
    const [loadingMensaje, setLoadingMensaje] = useState("")

    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });
    const history = useHistory()

    const [selectionModel, setSelectionModel] = React.useState([]);
    const [comercialSeleccionado, setComercialSeleccionado] = React.useState([]);

    const [comerciales, setComerciales] = useState(undefined)

    /* -------------------------------------------------------------------------- */
    /*                                  UseEffect                                 */
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
        setLoading(true)
        setLoadingMensaje("Cargando alumnos")

        const usuario_id = usuarioSeleccionado.id

        getAlumnosInteraccion({ usuario_id }).then((response) => {
          setLoading(false)

            response && setAlumnos(response.alumnos)
        });

    }, [])

    /* -------------------------------------------------------------------------- */
    /*                           Definicion de columnas                           */
    /* -------------------------------------------------------------------------- */

    const columnas = [
      { field: "id", headerName: "ID" },
      { field: "nombre", headerName: "Nombre", minWidth: 150, flex: 1 },
      { field: "alumno_desde", headerName: "Desde", minWidth: 150 },

      {
        field: "motivos_llamada_nombre",
        headerName: "Motivos contacto",
        minWidth: 150,
        flex: 1,
      },
      { field: "es_alumno_fast", headerName: "FAST", minWidth: 150, flex: 1 },
      {
        field: "ultimo_seguimiento",
        headerName: "Ultimo seguimiento",
        minWidth: 150,
        flex: 1,
        type: "date",
        valueFormatter: params => 
     moment(params?.value).format("DD/MM/YYYY hh:mm A"),
        // renderCell: (cellValues) => {
        //   return cellValues.value !== null &&
        //     cellValues.value !== "0000-00-00 00:00:00" ? (
        //     <Moment format="DD/MM/YYYY">{cellValues.value}</Moment>
        //   ) : (
        //     <></>
        //   );
        // },
      },

      {
        field: "especialidad_nombre",
        headerName: "Especialidad",
        minWidth: 150,
        flex: 1,
      },

      {
        field: "num_tickets_entregas_retrasados",
        headerName: "E. Retrasados",
        minWidth: 150,
        type: "number",
      },
      {
        field: "num_tickets_entregas_abiertos",
        headerName: "E. Abiertas",
        minWidth: 150,
        type: "number",
      },

      {
        field: "tutorias_individuales_consumidas",
        headerName: "T. Consumidas",
        minWidth: 150,
        type: "number",
      },
      {
        field: "tutorias_individuales_compradas",
        headerName: "T. Compradas",
        minWidth: 150,
        type: "number",
      },
      {
        field: "tutorias_individuales_disponibles",
        headerName: "T. Disponibles",
        minWidth: 150,
        type: "number",
      },

      {
        field: "simulacros_resueltos",
        headerName: "S. Resueltos",
        minWidth: 150,
        type: "number",
      },
      {
        field: "simulacros_abiertos",
        headerName: "S. Abiertos",
        minWidth: 150,
        type: "number",
      },
      {
        field: "simulacros_comprados",
        headerName: "S. Comprados",
        minWidth: 150,
        type: "number",
      },
      {
        field: "simulacros_disponibles",
        headerName: "S. Disponibles",
        minWidth: 150,
        type: "number",
      },

      {
        field: "num_tickets_pendientes",
        headerName: "D. Pendientes",
        minWidth: 150,
        type: "number",
      },
      {
        field: "num_tickets_resueltos",
        headerName: "D. Resueltas",
        minWidth: 150,
        type: "number",
      },
      {
        field: "num_tickets_abiertos",
        headerName: "D. Abiertas",
        minWidth: 150,
        type: "number",
      },
    ];

    /* -------------------------------------------------------------------------- */
    /*                                  Contenido                                 */
    /* -------------------------------------------------------------------------- */
    function QuickSearchToolbar(props) {
        const classes = useStyles();
      
        return (
          <div className={classes.rootFilter}>
            <div>
              <GridToolbarFilterButton />
              <GridToolbarDensitySelector />
            </div>
            <TextField
              variant="standard"
              value={props.value}
              onChange={props.onChange}
              placeholder="Buscar…"
              className={classes.textFieldFilter}
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
                endAdornment: (
                  <IconButton
                    title="Clear"
                    aria-label="Clear"
                    size="small"
                    style={{ visibility: props.value ? 'visible' : 'hidden' }}
                    onClick={props.clearSearch}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          </div>
        );
      }
      
      QuickSearchToolbar.propTypes = {
        clearSearch: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string.isRequired,
      };

    const Contenido = () => {
        const [rows, setRows] = React.useState(Alumnos);
        const [searchText, setSearchText] = React.useState('');
        const requestSearch = (searchValue) => {
          // console.log(searchValue)
          setSearchText(searchValue);
          const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
          // const searchRegex = new RegExp(`.*${searchValue}.*`, 'ig');
          const filteredRows = Alumnos.filter((row) => {
              return Object.keys(row).some((field) => {
                  // console.log(field)
                  // console.log(row)
                  return searchRegex.test(row[field]);
              });
          });
          setRows(filteredRows);
        };

        const handleAlumnoDetalle = (id) => {
          history.push('alumnos/detalle/' + id )
        }

        
        return (
            rows ?
                <>
                    <TituloPagina titulo={"Alumnos interacción"} />

                    <div style={{ height: 500, width: '100%', padding:"0 15px" }}>
                    
                        <DataGridInnovattio
                            rows={rows} 
                            columns={columnas} 
                            rowHeight={30}
                            components={{ Toolbar: QuickSearchToolbar }}
                            onDoubleClick={ (evento ) => handleAlumnoDetalle(evento.id) }
                            // checkboxSelection={usuarioSeleccionado.perfil_id === '1'}
                            // onSelectionModelChange={(newSelectionModel) => {
                            //   setSelectionModel(newSelectionModel);
                            // }}
                            // selectionModel={selectionModel}
                            componentsProps={{
                                toolbar: {
                                  value: searchText,
                                  onChange: (event) => requestSearch(event.target.value),
                                  clearSearch: () => requestSearch(''),
                                },
                            }}
                            // filterModel={filterModel}
                            // onFilterModelChange={(model) => setFilterModel(model)}
                        />
                    </div>

                    {/* <Typography variant='caption' style={{marginTop: 10, marginLeft: 16}}>NOTA: Ordenado por fecha de entrada de gasto decreciente</Typography> */}

                </>
                
                :
                <EmptyComponent mensaje="No hay datos para mostrar" />
        )
    }
    
    /* -------------------------------------------------------------------------- */
    /*                                   Return                                   */
    /* -------------------------------------------------------------------------- */
    return (
        <div className={classes.container}>
            {
                (loading ?
                    
                    <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
                    
                    :
                    
                    <Contenido />
                )
            }
        </div>
    )
}
